// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"supported-card-brands__icon___cyfIW","brand-icon":"supported-card-brands__brand-icon___4G8t0","brandIcon":"supported-card-brands__brand-icon___4G8t0"};
    if(module.hot) {
      // 1787773973401
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  